export const configUserMenu = [
	/* {
		title: 'Payment Information',
		url: '/paymets/add'
	}, */
	{
		title: 'Logout',
	}
];
